import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgMrt = function SvgMrt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#1AAF5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.719 3.333H3.284A8.157 8.157 0 0 1 6.343 1.23C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263a8.15 8.15 0 0 1 3.028 2.07ZM3.284 28.667h25.432a8.156 8.156 0 0 1-3.059 2.103C23.567 31.6 19.75 31.967 16 32c-3.75-.034-7.567-.432-9.658-1.23a8.157 8.157 0 0 1-3.058-2.103Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.008 10.925c-.005.135-.008.271-.008.408 0 5.523 4.477 10 10 10s10-4.477 10-10c0-.137-.003-.273-.008-.408.436 1.164.675 2.425.675 3.742 0 5.89-4.776 10.666-10.667 10.666-5.89 0-10.666-4.775-10.666-10.666 0-1.317.238-2.578.674-3.742Z",
    fill: "#F2C500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16 14.2-3.135 2.2 1.106-3.688-3.043-2.327 3.818-.079L16 6.666l1.254 3.64 3.818.079-3.043 2.327 1.106 3.688L16 14.2Z",
    fill: "#F2C500"
  }));
};

export default SvgMrt;